/**
 * Fred Olsen Cruise Lines Dynamica LTT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FilterDTO { 
    order?: number;
    displayName?: string;
    id?: string;
    visible?: boolean;
    filterControlType?: FilterDTO.FilterControlTypeEnum;
}
export namespace FilterDTO {
    export const FilterControlTypeEnum = {
        Multiple: 'MULTIPLE',
        Single: 'SINGLE',
        DatePicker: 'DATE_PICKER',
        DatePeriod: 'DATE_PERIOD',
        MonthPeriod: 'MONTH_PERIOD',
        Toggle: 'TOGGLE'
    } as const;
    export type FilterControlTypeEnum = typeof FilterControlTypeEnum[keyof typeof FilterControlTypeEnum];
}


